import React from "react";
import { ErrorMessage, useFormikContext } from "formik";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import {
  getLabelAndValue,
  processString,
} from "../../CommonFuntion/SchemaValidation";

const CssSelectField = styled(Select)({
  ".MuiSelect-select": {},
  "& label.Mui-focused": {
    color: "#ec0000c4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#ec0000c4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ec0000c4",
    },
    "&:hover fieldset": {
      borderColor: "#ec0000c4",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ec0000c4",
    },
  },
  "& div.MuiSelect-nativeInput": {
    fontSize: 12,
  },
});

export function ImageList(props) {
  const { name, label, options, tagName, prefix, validation } = props;

  const { setFieldValue, values } = useFormikContext();

  const handleChange = (e) => {
    setFieldValue([name], e.target.value);
  };
  const label2 = values[name];
  let Category, ImageID;
  if (label2?.length > 0) {
    let data;
    if (label2?.startsWith("[")) {
      data = options?.find((x) => x.value.split("|")[0] === label2)?.value;
    } else {
      data = options?.find((x) => x.label === label2)?.value;
    }
    const parts = getLabelAndValue(data);
    if (parts?.length >= 3) {
      // Format: label|Category|ImageID (e.g., [CAN]DO NOT BLEACH|Coin_Cin_Care|CIN05244)
      Category = parts[1];
      ImageID = parts[2];
    } else {
      [ImageID, Category] = parts || [];
      const { code } = processString(ImageID);
      ImageID = code ? code : ImageID;
    }
  }
  const id = `${name}`;
  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          <div>
            {label && (
              <label className="font-css" htmlFor={id}>
                {label.replace("_", " ")}

                {validation?.mandatory && (
                  <span className="mandatory-validation">{"*"}</span>
                )}
              </label>
            )}
          </div>
        </div>

        <div>
          <div className="control-bottom-border">
            <FormControl variant="standard" id={id}>
              <CssSelectField
                labelId={id}
                aria-label={label} // Use aria-label here
                id={id}
                name={name}
                key={name}
                tagname={tagName}
                fieldname={name}
                prefix={prefix}
                className="font-css"
                onChange={handleChange}
                label={values[name] || ""}
                value={values[name] || ""}
                style={{
                  fontSize: "12px",
                }}
              >
                <MenuItem
                  style={{
                    fontSize: "12px",
                  }}
                  value=""
                ></MenuItem>
                {options?.map((optn, index) => (
                  <MenuItem
                    style={{
                      fontSize: "12px",
                    }}
                    key={index}
                    value={
                      optn?.value?.split("|")[0].startsWith("[")
                        ? optn.value.split("|")[0]
                        : optn.label
                    }
                    label={optn.label}
                  >
                    {optn.label}
                  </MenuItem>
                ))}
              </CssSelectField>

              {Category && (
                <div>
                  <img
                    src={
                      process.env.REACT_APP_SITE_URL +
                      `/Pages/Utils/ShowImage.ashx?Category=${Category} &ImageID=${ImageID}`
                    }
                  />
                </div>
              )}
            </FormControl>

            <ErrorMessage
              name={name}
              render={(msg) => <div className="is-invalid">{msg}</div>}
            />
          </div>
        </div>
      </div>
    </>
  );
}
